import React from "react";
import Chip from "@mui/material/Chip";
import Avatar from "../avatar/Avatar";
import { Typography, Tooltip } from "@mui/material";

const UserChip = ({ code, name, id, photo, className, variant, maxWidth = '200px' }) => {
  return (
    <Chip
      id={id}
      variant={variant}
      className={[className, 'justify-start', `max-w-${maxWidth}`].join(' ')}
      component={'span'}
      label={
        <Tooltip arrow title={`${code} - ${name}`}>
          <Typography className="text-ellipsis text-nowrap">
            {code} - {name}
          </Typography>
        </Tooltip>
      }
      avatar={
        <Avatar 
          alt={code}
          src={`photos/${photo}`}
          size="xsmall"
        />
      }
    />
  );
};

export default UserChip;
